import styled from "@emotion/styled";

/**
 * Shell shared by the two "Today's Insight" cards — the unlocked
 * (MealTodayInsightsCard) and locked (MealTodayLockedCard) variants. Both sit in
 * the same slot above the stats block and overlap it by 20px, so they have to
 * agree on radius, shadow and vertical rhythm; keeping the styles here is what
 * guarantees the card doesn't shift when the daily insight unlocks.
 *
 * The unlocked card is the expand target, so the shell is a button; the locked
 * card renders it as a plain div via `as`. The height is fixed because the design
 * draws both states at the same 214px — the body fills whatever is left and the
 * fog covers the cut, so a long insight and a blurred placeholder occupy exactly
 * the same box.
 */
export const Card = styled.button`
  position: relative;
  z-index: 2;
  margin: 0 0 -20px;
  width: 100%;
  height: 13.375rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow: hidden;
  border: none;
  text-align: left;
  padding: 1rem;
  background: var(--color-white, #fff);
  border-radius: 1.5rem;
  box-shadow:
    -5px 5px 16px rgba(69, 49, 22, 0.08),
    -20px 20px 29px rgba(69, 49, 22, 0.07),
    -46px 45px 39px rgba(69, 49, 22, 0.03),
    -82px 81px 46px rgba(69, 49, 22, 0.01);

  cursor: pointer;

  &[data-interactive="false"] {
    cursor: default;
  }
`;

export const Label = styled.p`
  margin: 0;
  padding-right: 2rem;
  color: var(--color-charcoal-60);
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.33;
  letter-spacing: 0.48px;
  text-transform: uppercase;
`;

export const InsightWrap = styled.div`
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
`;

export const Insight = styled.p`
  margin: 0;
  color: var(--color-charcoal, #212121);
  font-family: "STK Bureau Serif", serif;
  font-size: 1rem;
  line-height: 1.4;
  letter-spacing: -0.16px;
  white-space: pre-line;
  height: 100%;
  overflow: hidden;
`;

export const Fog = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3rem;
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    var(--color-white, #fff)
  );
`;

export const Footer = styled.p`
  margin: 0;
  color: var(--color-charcoal-60);
  font-size: 0.75rem;
  line-height: 1.33;
`;
